module.exports = __webpack_public_path__ + "img/icon_setting_g.0768a4dc.svg";